import clsx from 'clsx';
import { Avatar, Body } from 'copilot-design-system';
import React from 'react';
import {
  SuggestionItemProps,
  SuggestionListItem,
  SuggestionListItemComponentProps,
} from 'stream-chat-react';

import { FlagsContext } from 'src/context';
import { getInitials } from 'src/utils/UserUtils';

const CustomUserItem = (props: SuggestionListItemComponentProps) => {
  const { EnableLegacyAvatarColorMapping } = React.useContext(FlagsContext);
  const entity = props.entity as any;
  const initials = getInitials(entity.name ?? entity.id, {
    twoLetters: true,
  });
  return (
    <div className="px-3 py-1 w-full flex items-center justify-start gap-3">
      <Avatar
        src={entity.image ?? ''}
        alt={entity.name ?? 'Avatar'}
        variant="circle"
        size="sm"
        fallbackColor={entity.fallbackColor}
        text={initials}
        useNewColors={EnableLegacyAvatarColorMapping}
      />
      <Body>{entity.name ?? entity.id}</Body>
    </div>
  );
};

export const CustomAutocompleteSuggestionItem = (
  props: SuggestionItemProps,
) => {
  const isUserMention =
    !('native' in props.item) &&
    'id' in props.item &&
    props.item.id &&
    !('description' in props.item);

  return (
    <SuggestionListItem
      {...props}
      className={clsx(props.className, props.focused && '!bg-secondary-hover')}
      component={isUserMention ? CustomUserItem : props.component}
    />
  );
};
